import {StyledListItem} from "@/shared/StyledComponents";
import {ProfilePhoto} from "@/shared/types";
import React, {ReactElement} from "react";
import {PracticePageProfile} from "@/libwyze-shared/types";

export function PracticesListView({practices, selectedPractice, setSelectedPractice}: {
  practices: PracticePageProfile[],
  selectedPractice: PracticePageProfile,
  setSelectedPractice: (practice: PracticePageProfile) => void
}): ReactElement {
  return <>
    {practices.map((practice) => <StyledListItem
      onClick={() => setSelectedPractice(practice)}
      selected={practice === selectedPractice}
      key={practice.getPage().id}
      img={ProfilePhoto(practice.basicInfo.profilePhoto, "/images/default_practice.png")}
      title={practice.basicInfo.name}
      text={practice.address.getAddress()}
    />)}
  </>;
}
